<template>
    <div :style="{'height':clientHeight-90+'px'}">
        <div >
            <div class="m-portlet m-b-10">
                <div class="m-portlet__body">
                    <el-form>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item label="日期">
                                    <el-date-picker
                                            v-model="year"
                                            type="year"
                                            :clearable="false"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期"
                                            @change="handleShow()">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="选择校区">
                                    <el-select v-model="section_ids"  placeholder="请选择校区"
                                               multiple
                                               clearable
                                               @change="handleShow()"
                                               >
                                        <el-option
                                                v-for="item in sections"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>


            <div class="m-portlet m-b-10" :style="{'height':(clientHeight-230)+'px'}" v-loading="loading">
                <div class="m-portlet__body">
                    <el-table :data="orderTableData"
                              border
                              :height="clientHeight-350"
                              size="middle"
                              style="width: 100%">
                        <el-table-column label="老师" prop="teacher_name" min-width="3%"></el-table-column>
                        <el-table-column label="一月" min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(1,scope.row.teacher_id)">{{scope.row.January.toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="二月"  min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(2,scope.row.teacher_id)">{{scope.row.February.toFixed(2)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column label="三月" min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(3,scope.row.teacher_id)">{{scope.row.march.toFixed(2)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column label="四月"  min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(4,scope.row.teacher_id)">{{scope.row.April.toFixed(2)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column label="五月" min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(5,scope.row.teacher_id)">{{scope.row.may.toFixed(2)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column label="六月" min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(6,scope.row.teacher_id)">{{scope.row.June.toFixed(2)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column label="七月"  min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(7,scope.row.teacher_id)">{{scope.row.July.toFixed(2)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column label="八月"  min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(8,scope.row.teacher_id)">{{scope.row.August.toFixed(2)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column label="九月"  min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(9,scope.row.teacher_id)">{{scope.row.September.toFixed(2)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column label="十月" min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(10,scope.row.teacher_id)">{{scope.row.October.toFixed(2)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column label="十一月"  min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(11,scope.row.teacher_id)">{{scope.row.November.toFixed(2)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column label="十二月"  min-width="3%">
                            <template slot-scope="scope">
                                <div @click="handleWorkloadDetail(12,scope.row.teacher_id)">{{scope.row.December.toFixed(2)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column label="汇总" prop="all" min-width="3%"></el-table-column>
                    </el-table>
                    <div class="text-center m-t-10">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                path: "/teacherWorkloadRenewal/list",
                loading: false,
                search_loading: true,
                year:this.$moment().format('YYYY-MM-DD'),
                section_ids:[],
                sections:[],
                tableData: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                Dialog_WorkloadDetail:{
                    workloadDetails:[
                        {
                            class_name:'',
                            section_name:'',
                            date_msg:[{
                                date:'',
                                period:''
                            }]
                        }
                    ],
                    loading:false
                }
            }
        },
        created() {
            this.handleCreate();
            this.handleInit();
            this.handleShow();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderTableData: function () {
                return this._.orderBy(this.tableData, 'all', 'desc');
            }
        },
        methods: {
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleInit(){
                this.$wApi.send(this.path, 'init', {});
            },
            handleData(event, data) {
                switch (event) {
                    case 'init':
                        this.sections = data.sections;
                        break;
                    case 'list':
                        this.tableData=data.datas
                        this.total=data.total
                        this.loading=false;
                        break;
                    case 'get_workloadDetail':
                        this.Dialog_WorkloadDetail.workloadDetails=data.datas
                        this.Dialog_WorkloadDetail.loading=false;
                        break;
                }
            },
            handleShow(currentPage=1){
                this.loading=true;
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize,
                    'section_ids':this.section_ids,
                    'year':this.year
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleShow(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleShow(this.currentPage, this.currentPageSize)
            },
            handleWorkloadDetail(month,teacher_id){
                this.$Win.openModal('Dialog_WorkloadDetail', 1800, 1000, '详情', {'month':month,'teacher_id':teacher_id});
            }
        }
    }
</script>

<style scoped>

</style>